import { Route, Routes } from "react-router-dom"
import { HomePage } from "./pages/Home"
import { LayoutNotAuth } from "./common/Layout/LayoutNoAuth"
import { LayoutAuth } from "./common/Layout/LayoutAuth"
import { ModuloPage } from "./pages/Modulos"
import { UnidadesAcademica } from "./componente/Home/UnidadesAcademica"
import { CentroDeInvestigacion } from "./componente/Home/CentroInvestigacion"
import { Estadisticas } from "./componente/Home/Estadisticas"
import { Odss } from "./componente/Home/Ods"
import { Busqueda } from "./pages/Busqueda"
import { ColaboracionesExternas } from "./pages/ColaboracionesExternas"
import { Investigador } from "./componente/Pages/Investigador"
import { HIndexTop } from "./componente/Home/HIndexTop"
import { Unidad } from "./componente/Pages/Unidad"
import { Centro } from "./componente/Pages/Centro"
import { Ods } from "./componente/Pages/Ods"
import { Publicacion } from "./componente/Pages/Publicacion"
import { NotFoundPage } from "./componente/Error/ErrorNotFound"
import { UnidadAdmin } from "./componente/Admin/Unidad"
import { CentroAdmin } from "./componente/Admin/Centro"
import { InvestigadorAdmin } from "./componente/Admin/Investigador"
import { Proyecto } from "./componente/Pages/Proyectos"
import RankingInvestigadores from "./pages/Ranking/RankingInvestigadores"
import { Login } from "./pages/Login"
import RankingVisualizador from "./pages/Ranking/RankingVisualizador"
import { LayoutAuthRanking } from "./common/Layout/LayoutAuthRanking"
import { useAppSelector } from "./redux/hooks"

export const AppRouter: React.FC<{}> = () => {
    const { rol } = useAppSelector((state) => state.authReducer);

    return (
        <Routes>

            <Route path="/" element={<LayoutNotAuth />} >
                <Route path="/" element={<HomePage />} >
                    <Route path="unidades" element={<UnidadesAcademica />} />
                    <Route path="centros" element={<CentroDeInvestigacion />} />
                    <Route path="estadisticas" element={<Estadisticas />} />
                    <Route path="odss" element={<Odss />} />
                    <Route path="hindextop" element={<HIndexTop />} />
                </Route>
            </Route>
            <Route path="/admin" element={<LayoutAuth />} >
                <Route path="/admin" element={<ModuloPage />} />
            </Route>
            <Route path="/admin/unidades" element={<LayoutAuth />} >
                <Route path="/admin/unidades" element={<UnidadAdmin />} />
            </Route>
            <Route path="/admin/centros" element={<LayoutAuth />} >
                <Route path="/admin/centros" element={<CentroAdmin />} />
            </Route>
            <Route path="/admin/investigadores" element={<LayoutAuth />} >
                <Route path="/admin/investigadores" element={<InvestigadorAdmin />} />
            </Route>
            <Route path="/busqueda" element={<LayoutNotAuth />} >
                <Route path="/busqueda" element={<Busqueda />} />
            </Route>
            <Route path="/colaboracion" element={<LayoutNotAuth />} >
                <Route path="/colaboracion" element={<ColaboracionesExternas />} />
            </Route>
            <Route path="/investigador/:id" element={<LayoutNotAuth />} >
                <Route path="/investigador/:id" element={<Investigador />} />
            </Route>
            <Route path="/unidad/:nombre_unidad" element={<LayoutNotAuth />} >
                <Route path="/unidad/:nombre_unidad" element={<Unidad />} />
            </Route>
            <Route path="/centro/:nombre_centro" element={<LayoutNotAuth />} >
                <Route path="/centro/:nombre_centro" element={<Centro />} />
            </Route>
            <Route path="/publicacion/:id" element={<LayoutNotAuth />} >
                <Route path="/publicacion/:id" element={<Publicacion />} />
            </Route>
            <Route path="/proyecto/:id" element={<LayoutNotAuth />} >
                <Route path="/proyecto/:id" element={<Proyecto />} />
            </Route>
            <Route path="/ods/:id" element={<LayoutNotAuth />} >
                <Route path="/ods/:id" element={<Ods />} />
            </Route>
            <Route path="*" element={<LayoutNotAuth />} >
                <Route path="*" element={<NotFoundPage />} />
            </Route>
            <Route path="login" element={<Login />} >
                <Route path="/login" element={<Login />} />
            </Route>
            {rol === "ADMIN RANKING INVESTIGACIÓN" && (
                <Route element={<LayoutAuthRanking />}>
                    <Route path="/Ranking/consulta" element={<RankingInvestigadores />} />
                </Route>
            )}
            {(rol === "ADMIN RANKING INVESTIGACIÓN" || rol === "LECTOR RANKING INVESTIGACIÓN") && (
                <Route path="/Ranking/visualizar" element={<LayoutAuthRanking />} >
                    <Route path="/Ranking/visualizar" element={<RankingVisualizador />} />
                </Route>
            )}
        </Routes>
    )
}